import r from "./_cb.js";
import i from "./pluck.js";
import t from "./map.js";
function e(e, n, o) {
  var u = 0;
  return n = r(n, o), i(t(e, function (r, i, t) {
    return {
      value: r,
      index: u++,
      criteria: n(r, i, t)
    };
  }).sort(function (r, i) {
    var t = r.criteria,
      e = i.criteria;
    if (t !== e) {
      if (t > e || void 0 === t) return 1;
      if (t < e || void 0 === e) return -1;
    }
    return r.index - i.index;
  }), "value");
}
export { e as default };